/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Parties_TitleInputs */

const da_terms_parties_title = /** @type {(inputs: Terms_Parties_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parterne`)
};

/** @type {(inputs: Terms_Parties_TitleInputs) => LocalizedString} */
const en_terms_parties_title = da_terms_parties_title;

/**

* @param {Terms_Parties_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_parties_title = /** @type {((inputs?: Terms_Parties_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Parties_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_parties_title(inputs)
	return /** @type {LocalizedString} */ ("Parterne")
});